import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { GiPlatform } from 'react-icons/gi';
import "./index.css";
import { translate } from '../../../../utils/Common';
import { FaColumns, FaDoorOpen, FaSave, FaEdit, FaTrashAlt, FaArrowCircleRight, FaPlus, FaNetworkWired, FaEthernet } from 'react-icons/fa';
import { MdLockOutline, MdOutlineSevereCold } from 'react-icons/md';
import { usePlatforms } from '../../../../hooks/usePlatforms';
import { FaComputer } from 'react-icons/fa6';
import { ToastContainer, useToast } from '../../../../components/common/Toast';
import BtnSync from '../../../../components/BtnSync';
import Button from '../../../../components/common/Button/Button';
import AppleSpinner from '../../../../components/AppleSpinner';
import { getProviderCapabilities, isModuleNetwork, isModuleSharedIp, isModuleNetworkPort, isValidNetworkPort, REGEX_IP_ADDRESS } from '../../../../config/providers';
import { LuNetwork, LuPlug } from 'react-icons/lu';
import { Badge } from '@/components/ui/badge';

const FormModulesLocker = (props) => {
    const { setOptionSelect, setConfigLocker, configLocker, externalId, settingsLocker, handleGetInfoPlatform, setEditModeModule, editModeModule, isLoadingData, permissions, optionsProviders } = props;
    const canUpdate = !!permissions?.canUpdate;
    const canSyncDetails = !!permissions?.canSyncDetails;
    const { toasts, showSuccess, showError, removeToast } = useToast();
    const [isLoading, setIsLoading] = useState(false);
    const { createModulesPlatform, updateModulesPlatform } = usePlatforms();
    const [originalConfigLocker, setOriginalConfigLocker] = useState(null);
    // Multi-Vendor: cada módulo elige su proveedor al crearse, y después no se cambia
    const isMultiVendor = !!getProviderCapabilities(settingsLocker?.IdFabricante, optionsProviders)?.multiVendor;
    const moduleProviderOptions = (optionsProviders || []).filter(provider => !getProviderCapabilities(provider.id, optionsProviders)?.multiVendor);
    // proveedores por red (Zhilai, Mercury): el módulo lleva IP en lugar de puerto COM
    const isNetworkModule = (module) => isModuleNetwork(module, settingsLocker?.IdFabricante, optionsProviders);
    // Mercury: el módulo de red también lleva su puerto TCP, guardado en Com
    const hasNetworkPort = (module) => isModuleNetworkPort(module, settingsLocker?.IdFabricante, optionsProviders);
    // IP sugerida: una por módulo (192.168.1.1{módulo}); en Mercury todos los módulos usan la misma,
    // así que se repite la de otro módulo Mercury del locker en lugar de incrementarla
    const getDefaultIpAddress = (module, index) => {
        if (!isModuleSharedIp(module, settingsLocker?.IdFabricante, optionsProviders)) return `192.168.1.1${module?.moduleNumber || (index + 1)}`;
        // en Multi-Vendor, la de otro módulo del mismo proveedor
        const sharedIp = configLocker.modules.find(other => other !== module && other.ipAddress
            && isModuleSharedIp(other, settingsLocker?.IdFabricante, optionsProviders)
            && (!isMultiVendor || Number(other.providerId) === Number(module?.providerId)))?.ipAddress;
        return sharedIp || '192.168.1.11';
    };
    // nombre del proveedor de un módulo ya agregado: el que manda el API o, recién creado, el del catálogo
    const getModuleProviderName = (module) => {
        if (!module?.providerId || getProviderCapabilities(module.providerId, optionsProviders)?.multiVendor) return null;
        return module.providerName || optionsProviders?.find(provider => Number(provider.id) === Number(module.providerId))?.value || null;
    };

     // Obtener el último número de puerta creado
     const getLastDoorNumber = () => {
        let lastDoorNumber = 0;
        configLocker.modules.forEach(module => {
            module.columns.forEach(column => {
                column.doors.forEach(door => {
                    if (Number(door.doorNumber) > lastDoorNumber) { // Asegurarse de que sea número
                        lastDoorNumber = Number(door.doorNumber);
                    }
                });
            });
        });
        return lastDoorNumber;
    }

    // Crear un nuevo módulo
    const createRenderModule = () => {
        if (!canUpdate) return;
        const lastDoorNumber = getLastDoorNumber();
        setConfigLocker({
            ...configLocker,
            modules: [...configLocker.modules, 
                {
                    moduleNumber: configLocker.modules.length + 1, 
                    numColumns: 2, 
                    numDoors: 20,
                    columns: [],
                    status: 1, // Estado inicial como borrador
                    startDoorNumber: lastDoorNumber + 1, // Almacenar el número inicial,
                    locationId: externalId,
                    moduleId: null,
                    providerId: null
                }
            ]
        });
    }

 // Generar datos del módulo
 const addDataModuleLocker = (moduleId, data) => {
    const { totalDoors, columns, startDoorNumber } = data;

    const doorsPerColumn = Math.floor(totalDoors / columns);
    const remainder = totalDoors % columns;

    let result = {
        moduleNumber: moduleId,
        columns: []
    };

    let doorCounter = Number(startDoorNumber); // Asegurar número
    let globalSequence = 1; // doorSequence global por módulo (1..totalDoors) para alinear con doorOrder en BD

    for (let i = 0; i < columns; i++) {
        // Distribuir las puertas asignando los "sobrantes" (remainder)
        // a las últimas columnas, de forma que los espacios borrador
        // nuevos se generen al final (última columna).
        let doorsInThisColumn = doorsPerColumn + (i >= columns - remainder ? 1 : 0);
        let column = {
            columnId: i + 1,
            doors: []
        };

        for (let j = 0; j < doorsInThisColumn; j++) {
            column.doors.push({
                doorNumber: doorCounter++,
                dimension: "S",
                layer: "H",
                doorSequence: globalSequence++,
                boxitDoorId: 0,
                columnModule: i + 1,
                id: uuidv4(),
                isActive: true,
                isScreen: false,
                locationId: externalId,
                moduleNumber: moduleId
            });
        }

        result.columns.push(column);
    }

    return result;
}

    // Actualizar los módulos
    const updateRenderModuleData = (index, data) => {
        if (!canUpdate) return;
        const { numDoors, numColumns, isRefrigerated, isUnitCentral, comPort, ipAddress, port } = data;
        if (numDoors <= 0 || numColumns <= 0) {
             showError('Values must be greater than zero!');
            return;
        }

        const module = configLocker.modules[index];
        if (isMultiVendor && !module.providerId) {
            showError(translate("global.selectModuleProvider"));
            return;
        }

        const isNetwork = isNetworkModule(module);
        if (isNetwork && !REGEX_IP_ADDRESS.test(ipAddress || '')) {
            showError(translate("global.invalidIpAddress"));
            return;
        }
        const usesPort = hasNetworkPort(module);
        if (usesPort && port && !isValidNetworkPort(port)) {
            showError(translate("global.invalidPort"));
            return;
        }

        if (isUnitCentral && hasCentralUnit() && !configLocker.modules[index].isUnitCentral) {
            showError('Ya existe una unidad central. Solo puede haber una unidad central.');
            return;
        }

        const updatedModules = [...configLocker.modules];
        const moduleId = updatedModules[index].moduleNumber;
        const startDoorNumber = updatedModules[index].startDoorNumber || getLastDoorNumber() + 1;
        const dataSend = {
            numDoors: parseInt(numDoors), numColumns: parseInt(numColumns), startDoorNumber: startDoorNumber, totalDoors: numDoors, columns: numColumns
        }

        const moduleData = addDataModuleLocker(moduleId, dataSend);
        updatedModules[index] = {
            ...updatedModules[index],
            numDoors,
            numColumns,
            columns: moduleData.columns,
            status: 2, // Cambiar estado a editable,
            isRefrigerated,
            isUnitCentral,
            com: isNetwork ? (usesPort && port ? String(Number(port)) : null) : comPort,
            ipAddress: isNetwork ? ipAddress : null
        };

        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    const editModule = (index) => {
      const updatedModules = [...configLocker.modules];
      updatedModules[index].status = 1; // Estado editable
      setConfigLocker({
          ...configLocker,
          modules: updatedModules
      });
    }

    const deleteModule = (index) => {
        const updatedModules = configLocker.modules.filter((_, i) => i !== index);
        let doorCounter = 1;
  
        updatedModules.forEach((module, i) => {
            module.moduleNumber = i + 1; // Reordenar los números de los módulos
            module.startDoorNumber = doorCounter;
  
            module.columns.forEach(column => {
                column.doors.forEach(door => {
                    door.doorNumber = doorCounter++;
                });
            });
        });
  
        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    const hasNonDraftModule = configLocker.modules.some(module => module.status === 2);
    const hasDraftModule = configLocker.modules.some(module => module.status === 1);
    const hasModuleInBd = configLocker.modules.some(module => module.status === 3);
    const hasCentralUnit = () => {
        return configLocker.modules.some(module => module.isUnitCentral);
    }   

    const handleChangeColumns = (index, value) => {
        const updatedModules = [...configLocker.modules];
        const currentModule = { ...updatedModules[index] };
        const numColumns = Number(value) || 0;

        currentModule.numColumns = numColumns;

        const maxDoors = numColumns === 1 ? 12 : 20;
        if (currentModule.numDoors > maxDoors) {
            currentModule.numDoors = maxDoors;
        }

        updatedModules[index] = currentModule;

        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    // el proveedor decide si el borrador pide COM o IP, por eso va en el estado y no se lee del DOM
    const handleChangeProvider = (index, value) => {
        const updatedModules = [...configLocker.modules];
        updatedModules[index] = { ...updatedModules[index], providerId: Number(value) || null };
        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    const handleChangeDoors = (index, value) => {
        const updatedModules = [...configLocker.modules];
        const currentModule = { ...updatedModules[index] };

        const numColumns = Number(currentModule.numColumns) || 2;
        const maxDoors = numColumns === 1 ? 12 : 20;

        let doors = parseInt(value, 10) || 0;
        if (doors > maxDoors) {
            doors = maxDoors;
        }

        currentModule.numDoors = doors;
        updatedModules[index] = currentModule;

        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    const getModuleDoorBoardData = (module, details) => {        

        const getPositionBoard = (moduleIndex) => { 
            // Verificar si el módulo actual es una unidad central
            if (configLocker.modules[moduleIndex]?.isUnitCentral) {
                return "C"; // Unidad central
            } else {
                // Determinar si está a la izquierda o derecha de la unidad central
                const centralIndex = configLocker.modules.findIndex(mod => mod.isUnitCentral); // Buscar unidad central
                if (centralIndex === -1) return ""; // No hay unidad central
                
                // Comparar los índices para determinar la posición
                return moduleIndex < centralIndex ? "L" : "R"; // Comparar el índice del módulo con el de la unidad central
            }
        };
        
        const isNetwork = isNetworkModule(module);
        const defaultValue = {
            locationId: details.externalId,
            module: String(module.moduleNumber),
            doorQty: Number(module.numDoors),
            columnQty: Number(module.numColumns),
            position: getPositionBoard(module.indexModule),
            refrigerated: module.isRefrigerated,
            status: module.status,
            comPort: !isNetwork ? "COM"+ module.com : null,
            ipAddress: isNetwork ? module.ipAddress : null,
            ...(hasNetworkPort(module) && module.com && { port: module.com }),
            ...(isMultiVendor && { providerId: Number(module.providerId) }),
        }

        return defaultValue;
        
    };
    
    const handleSaveModulesPlatforms = async () => {
        if (!canUpdate) return;
        
        if (!hasCentralUnit()) {
            showError(translate("global.verifyModuleCentral"));
            return; // No continuar si no hay módulo central
        }
    
        setIsLoading(true);
        


    // Procesar solo los módulos filtrados
    const modules = (configLocker.modules.map((module, index) => {
        const response = getModuleDoorBoardData({...module, indexModule: index}, settingsLocker);
        return response;
    }));

           // Filtrar los módulos con status 2
    const filteredModules = modules.filter(module => module.status === 2);

    const dataToSend = {
        modules: filteredModules,
        settings: settingsLocker
    }

    const response = await createModulesPlatform(dataToSend);

    if (response?.code === 200 && response?.payload) {
        const createdModules = response.payload.map(item => ({
            id: item.boxitBoardId,
            module: item.moduleId,
            status: item.message
        }));

        const modulesText = createdModules.map((module, index) => 
            `${translate("global.module")} ${module.module}${index < createdModules.length - 1 ? ", " : ""}`
        ).join("");
        
        showSuccess(`${translate("global.createSuccessModule")}: ${modulesText}`);
        setOptionSelect('doors');
    }

    setIsLoading(false);
    handleGetInfoPlatform(externalId);
    }

    const handleSelectEditModule = (module) => {
        if (!canUpdate) return;
        setEditModeModule(true);
        // Cambiar de status de los módulos
        const updatedModules = [...configLocker.modules];
        updatedModules.forEach((mod, index) => {
            if (mod.moduleId === module.moduleId) {
                updatedModules[index].status = 4; // Estado actualizable
            } else {
                updatedModules[index].status = 3; // Estado bloqueado
            }
        });        

        setConfigLocker({
            ...configLocker,
            modules: updatedModules
        });
    }

    const handleUpdateModule = async (data) => {
        if (!canUpdate) return;

        const isNetwork = isNetworkModule(data);
        if (isNetwork && !REGEX_IP_ADDRESS.test(data.ipAddress || '')) {
            showError(translate("global.invalidIpAddress"));
            return;
        }
        const usesPort = hasNetworkPort(data);
        if (usesPort && data.port && !isValidNetworkPort(data.port)) {
            showError(translate("global.invalidPort"));
            return;
        }

        setIsLoading(true);

        const dataSend = {
            ...data,
            comPort: !isNetwork ? ( data.comPort  ? "COM"+ data.comPort : null) : null,
            columnQty: data.columnQty,
            port: usesPort ? (data.port ? String(Number(data.port)) : '') : undefined,
        }
        
        const response = await updateModulesPlatform(dataSend);

        if (response?.code===200 && response?.message === 'MODULE_UPDATED') {
            // mandar mensaje de actualización correcta
            showSuccess(`${translate("global.updateSuccessModule")} ${translate("global.module")} ${data.module}`);

            // Actualizar el estado de los módulos
            const updatedModules = [...configLocker.modules];
            updatedModules.forEach((mod, index) => {
                if (mod.moduleId === data.moduleId) {
                    updatedModules[index].status = 3; // Estado bloqueado
                    updatedModules[index].numDoors = data.doorQty;
                    updatedModules[index].numColumns = data.columnQty;
                    updatedModules[index].isRefrigerated = data.refrigerated;
                    updatedModules[index].isUnitCentral = data.isUnitCentral;
                    updatedModules[index].com = usesPort ? (data.port ? String(Number(data.port)) : null) : (data.comPort > 0 ? data.comPort : null);
                    if (data.ipAddress !== undefined) updatedModules[index].ipAddress = data.ipAddress;
                }
            });
            setConfigLocker({
                ...configLocker,
                modules: updatedModules
            });

            await handleGetInfoPlatform(externalId);
            
        }else{
            showError(translate("dashboard.packages.details.dropOff.receivePackage.NOT_FOUND"));
            }
     
        setIsLoading(false);
    }
    
    const handleCancelSelectEditModule = () => {
            // Regresa a status 3 los módulos
            const updatedModules = [...configLocker.modules];
            updatedModules.forEach((mod, index) => {
                updatedModules[index].status = 3;
            });
            setConfigLocker({
                ...configLocker,
                modules: updatedModules
            });

            setEditModeModule(false);
           
    }
    
    
        useEffect(() => {
          if (editModeModule) {
            // Guarda los estados originales al entrar en modo edición
            setOriginalConfigLocker(JSON.parse(JSON.stringify(configLocker)));
          }
        }, [editModeModule]);

    return (
        <div className='cardInternal'>
            <div className="cardInternal-header">
                <div className='cardInternal-title'>
                    <span className="mr-1"><GiPlatform size={20} /></span>
                    {translate( "global.modules")}
                </div>
                <div style={{ display:'flex', alignItems: 'center', gap: '5px'}}>

                </div>
                {
                    hasNonDraftModule && (
                      <div className="cardInternal-actions">
                        <Button variant="primary" size="sm" leftIcon={<FaSave />} onClick={() => handleSaveModulesPlatforms()} loading={isLoading} disabled={!canUpdate}>
                          {translate("global.save")} 
                        </Button>
                      </div>
                    )
                  }

{
    hasModuleInBd && (
<div>
                        <Button variant="ghostOutline" size="sm" rightIcon={<FaArrowCircleRight />} onClick={() => setOptionSelect('doors')}>
                            {translate("login.signup.btn.next")}
                        </Button>
                  </div>
    )
}
                  
            </div>

            <div className="cardInternal-body">

                {isLoadingData ? (
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center', 
                        padding: '3rem'
                    }}>
                        <AppleSpinner size={40} />
                    </div>
                ) : (
                <>
                {
                        !editModeModule && (
                            <Button variant="ghostOutline" size="sm" leftIcon={<FaPlus />} onClick={() => !hasDraftModule && createRenderModule()} disabled={hasDraftModule || !canUpdate}>
                            {translate("global.addModule")}
                        </Button>
                        )
                    }
               

                <div className="modules-list mt-2 p-2">
                    {configLocker.modules.map((module, index) => (
                        <div key={index} className="module-item">
                            <div className="module-header">
                                <div className="flex min-w-0 items-center gap-2">
                                    <div className="module-title">
                                        {translate("dashboard.platforms.module")} {module.moduleNumber}
                                    </div>
                                    {
                                        // en Multi-Vendor cada módulo es de un proveedor distinto; en el borrador ya lo dice el select
                                        isMultiVendor && module.status !== 1 && getModuleProviderName(module) && (
                                            <Badge variant="muted" className="gap-1 px-2 text-[11px] font-semibold uppercase tracking-wide" title={translate("global.moduleProvider")}>
                                                {isNetworkModule(module) ? <LuNetwork size={12} strokeWidth={2.25} /> : <LuPlug size={12} strokeWidth={2.25} />}
                                                {getModuleProviderName(module)}
                                            </Badge>
                                        )
                                    }
                                </div>

                                <div className="module-actions">
                                    {module.status === 1 && (
                                        <Button 
                                            variant="primary"
                                            size="sm"
                                            leftIcon={<FaPlus />}
                                            onClick={() => {
                                                const numDoors = document.getElementById(`doors-${index}`).value;
                                                const numColumns = document.getElementById(`columns-${index}`).value;
                                                const isRefrigerated = document.getElementById(`switchCheckRefrigerated-${index}`)?.checked;
                                                const isUnitCentral = document.getElementById(`switchCheckUnitCentral-${index}`)?.checked || false;
                                                const comPort = document.getElementById(`com-${index}`)?.value;
                                                const ipAddress = document.getElementById(`ipAddress-${index}`)?.value?.trim();
                                                const port = document.getElementById(`port-${index}`)?.value?.trim();
                                                const dataSend = {numDoors, numColumns, isRefrigerated, isUnitCentral, comPort, ipAddress, port};
                                                updateRenderModuleData(index, dataSend);
                                            }}
                                            disabled={!canUpdate}
                                        >
                                            {translate("global.add")}
                                        </Button>
                                    )}

{module.status === 2 && (
                                        <>
                                            <Button 
                                                variant="primary"
                                                size="sm"
                                                leftIcon={<FaEdit />}
                                                onClick={() => editModule(index)}
                                            >
                                                {translate("global.edit")}
                                            </Button>
                                            <Button 
                                                variant="ghostOutline"
                                                size="sm"
                                                leftIcon={<FaTrashAlt />}
                                                onClick={() => deleteModule(index)}
                                            >
                                                {translate("global.delete")}
                                            </Button>
                                        </>
                                    )}

                                    <div style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                                        
                                    {canSyncDetails && (module.status === 3 && module?.boardId > 0) && <BtnSync mode="module" size={"sm"} boardId={module?.boardId} /> }

                                    {(module.status === 3) && (
                                        <FaEdit size={18} className='icon-click' onClick={()=> {handleSelectEditModule(module)}}/>
                                    )}

                                    {module.status === 3 && (
                                        <MdLockOutline size={20} />
                                    )}                          
                                    </div>

                                    {module.status === 4 && (
                                        <div className='flex items-center' style={{gap: '10px'}}>
                                            <Button
                                            variant="ghostOutline"
                                            size="sm"
                                            onClick={()=>handleCancelSelectEditModule()}
                                            >
                                                 {translate("global.cancel")}
                                            </Button>
 <Button variant="primary" size="sm" leftIcon={<FaSave />} onClick={() => 
                                        {
                                                const moduleId = module.moduleId;
                                                const numDoors = document.getElementById(`doors-${index}`).value;
                                                const numColumns = document.getElementById(`columns-${index}`).value;
                                                const isRefrigerated = document.getElementById(`switchCheckRefrigerated-${index}`)?.checked;
                                                const isUnitCentral = document.getElementById(`switchCheckUnitCentral-${index}`)?.checked || false;
                                                const comPort = document.getElementById(`com-${index}`)?.value;
                                                const ipAddress = document.getElementById(`ipAddress-${index}`)?.value?.trim();
                                                const port = document.getElementById(`port-${index}`)?.value?.trim();
                                                const dataSend = {...module, port, moduleId, doorQty: Number(numDoors), columnQty: Number(numColumns), refrigerated: isRefrigerated, isUnitCentral, module: module.moduleNumber, comPort: comPort, ipAddress: isNetworkModule(module) ? ipAddress : undefined};
                                                handleUpdateModule(dataSend);
                                        }} loading={isLoading}>
                                             {translate("global.save")} 
                                        </Button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="module-content">
                                {(module.status === 1 || module.status === 4) && (
                                    <div className="flex flex-wrap">
                                        {
                                            // solo al crear: el proveedor de un módulo guardado no se cambia
                                            isMultiVendor && module.status === 1 && (
                                                <div className="w-full mb-3">
                                                    <label className="text-label-title-dark">
                                                        {translate("global.moduleProvider")} <span className='text-destructive'>*</span>
                                                    </label>
                                                    <select
                                                        id={`provider-${index}`}
                                                        className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed'
                                                        value={module.providerId || ''}
                                                        onChange={(e) => handleChangeProvider(index, e.target.value)}
                                                    >
                                                        <option value="">{translate("global.select")}...</option>
                                                        {moduleProviderOptions.map((provider) => (
                                                            <option key={provider.id} value={provider.id}>{provider.value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )
                                        }
                                        <div className="w-full md:w-6/12">
                                            <label className="text-label-title-dark">
                                                <FaDoorOpen className='mr-1'/>  {translate("global.Doors")}
                                            </label>
                                            <select 
                                                id={`doors-${index}`} 
                                                className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed'
                                                value={module.numDoors}
                                                onChange={(e) => handleChangeDoors(index, e.target.value)}
                                            >
                                                {Array.from({ length: (Number(module.numColumns) === 1 ? 12 : 20) }, (_, i) => i + 1).map((value) => (
                                                    <option key={value} value={value}>{value}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="w-full md:w-6/12">
                                            <label className="text-label-title-dark">
                                                <FaColumns className='mr-1' /> {translate("global.columns")}
                                            </label>
                                            <select 
                                                id={`columns-${index}`} 
                                                className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed'
                                                value={module.numColumns}
                                                onChange={(e) => handleChangeColumns(index, e.target.value)}
                                            >
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                            </select>
                                        </div>
                                        
                                        <div className="w-full md:w-6/12 mt-3">
                                             <div className="flex items-center gap-2 form-switch">
                                                <input className="size-4 cursor-pointer accent-primary" type="checkbox" id={`switchCheckRefrigerated-${index}`}  defaultChecked={module.isRefrigerated}/>
                                                <label className="cursor-pointer text-sm text-foreground" for={`switchCheckRefrigerated-${index}`} ><MdOutlineSevereCold className='mr-1' size={18} /> {translate("global.refrigerated")}</label>
                                             </div>
                                        </div>
                                        {
                                            (!hasCentralUnit() || module.isUnitCentral) && (
                                             <div className="w-full md:w-6/12 mt-3">                                          
                                                <div className="flex items-center gap-2 form-switch">
                                                    <input className="size-4 cursor-pointer accent-primary" type="checkbox" id={`switchCheckUnitCentral-${index}`} defaultChecked={module.isUnitCentral} disabled={module.isUnitCentral}/>
                                                    <label className="cursor-pointer text-sm text-foreground" for={`switchCheckUnitCentral-${index}`}><FaComputer className='mr-1' size={18}/>{translate("global.unitCentral")}</label>
                                                 </div>
                                            </div>
                                            )
                                        }

<div className='row p-3 w-100'>
{
    // Multi-Vendor sin proveedor elegido todavía no sabe si pide COM o IP
    !(isMultiVendor && module.status === 1 && !module.providerId) && !isNetworkModule(module) && (
        <div className='w-full md:w-6/12'>
        <label className="text-label-title-dark">
             COM
        </label>
            <input 
                type="number" 
                id={`com-${index}`} 
                className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed' 
                defaultValue={module?.com?.length > 0 ? module.com.replace(/\D/g, '') : '3'}
            />
        </div>
    )
}
{
    // la IP se ingresa al crear el módulo (status 1) y al editarlo (status 4). En Mercury el puerto
    // va en la misma fila: grid fijo y no anchos por breakpoint, porque el panel es angosto aunque la pantalla no
    isNetworkModule(module) && (
        <div className={`grid w-full gap-3 ${hasNetworkPort(module) ? 'grid-cols-[minmax(0,1fr)_7rem]' : 'grid-cols-1 md:w-6/12'}`}>
            <div className='min-w-0'>
                <label className="text-label-title-dark" htmlFor={`ipAddress-${index}`}>
                     <FaNetworkWired className='mr-1' size={16} /> {translate("global.ipAddress")} <span className='text-destructive'>*</span>
                </label>
                <input
                    type="text"
                    id={`ipAddress-${index}`}
                    className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed'
                    placeholder="192.168.1.11"
                    defaultValue={module?.ipAddress || getDefaultIpAddress(module, index)}
                />
            </div>
            {
                // Mercury: puerto TCP del módulo, opcional (vacío = el locker usa su puerto por defecto)
                hasNetworkPort(module) && (
                    <div className='min-w-0'>
                        <label className="text-label-title-dark" htmlFor={`port-${index}`}>
                             <FaEthernet className='mr-1' size={16} /> {translate("global.port")}
                        </label>
                        <input
                            type="text"
                            inputMode="numeric"
                            maxLength={5}
                            id={`port-${index}`}
                            className='h-11 w-full rounded-lg border border-transparent bg-muted/60 px-3 text-sm text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed tabular-nums'
                            placeholder="-"
                            defaultValue={module?.com || ''}
                        />
                    </div>
                )
            }
        </div>
    )
}
</div>

                                       
                                       
                                    </div>
                                )}

                                {(module.status !== 1 && module.status !== 4) && (
                                    <div className="module-info-display">
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                        <FaDoorOpen className='mr-1'/> <span className='text-bold mr-1'>{module.numDoors}</span> {translate("global.Doors")}
                                        </div>
                                        -
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                        <FaColumns className='mr-1' /><span className='text-bold mr-1'>{module.numColumns}</span> {translate("global.columns")}
                                        </div>
                                        
                                        {module.isRefrigerated && (
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                                 <span className='mr-1'>-</span> <MdOutlineSevereCold size={18} className="module-icon-refrigerated" />
                                            </div>
                                        )}
                                       
                                        {module.isUnitCentral && (
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                              <span className='mr-1'>-</span> <FaComputer  size={18} className="module-icon-central"/>
                                            </div>
                                        )}

                                        {!isNetworkModule(module) && module?.com && (
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                              {/* el puerto llega como "3" o "COM3": se muestra siempre "COM 3" */}
                                              <span className='mr-1'>-</span> <span className='mr-1'>COM</span><span className='text-bold'>{String(module.com).replace(/\D/g, '') || module.com}</span>
                                            </div>
                                        )}
                                        {isNetworkModule(module) && module?.ipAddress && (
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                              <span className='mr-1'>-</span> <FaNetworkWired size={18} className='mr-1' /> <span className='text-bold'>{module.ipAddress}{hasNetworkPort(module) && module?.com ? `:${module.com}` : ''}</span>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                </>
                )}
            </div>
            {/* Toast Notifications */}
            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </div>
    )
}

export default FormModulesLocker;
